// Default forecaster selection: ensemble only. Used to reset the dashboard's
// forecaster picker (e.g. when cancelling the large-query performance warning,
// which drops the per-forecaster selection back to just the ensemble).
export const DEFAULT_SELECTED_FORECAST = [{ id: null, name: 'Ensemble' }];
